import { useEffect, useState } from "react";

import algoliasearch, { SearchClient } from "algoliasearch/lite";

export const useSearchCredentials = () => ({
    applicationId: process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    searchKey: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
});

export const useSearchClient = () => {
    const { applicationId, searchKey } = useSearchCredentials();

    const [searchClient, setSearchClient] = useState<SearchClient | null>(null);

    useEffect(() => {
        setSearchClient(algoliasearch(applicationId, searchKey));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return searchClient;
};
